import React, { FC } from 'react';
import { View, TouchableOpacity, Text } from 'react-native';
import styles from './styles';

export type GenreButtonProps = {
  containerStyle?: any;
  isActive?: boolean;
  genreObj: any;
  limitReached?: boolean;
  minSelectedThreshold: boolean;
  onPress: (e: any) => void;
};

export const GenreButton: FC<GenreButtonProps> = (props) => {
  const {
    genreObj = {},
    onPress,
    isActive,
    containerStyle,
    limitReached = false,
    minSelectedThreshold,
  } = props;

  const showDisabledButton = !isActive && limitReached;
  let buttonStyle;
  let isDisabled = false;
  if (isActive) {
    buttonStyle = styles.activeButtonStyle;
    isDisabled = minSelectedThreshold;
  } else if (showDisabledButton) {
    buttonStyle = styles.disabledButtonStyle;
    isDisabled = true;
  } else {
    buttonStyle = styles.unSelectedButtonStyle;
  }

  return (
    <View style={[styles.container, containerStyle]}>
      <TouchableOpacity
        disabled={isDisabled}
        onPress={() => onPress({ id: genreObj.id, genre: genreObj.genre })}
        style={buttonStyle}
      >
        <Text style={styles.text}>{genreObj.genre}</Text>
      </TouchableOpacity>
    </View>
  );
};

export default GenreButton;
